'use client';

import { useSuperstarDetails } from '@wwe-portal/web/providers/queries/superstar';
import { FC, ReactNode } from 'react';
import { SuperstarDetailProvider } from './context';
import { StatsDetailsSkeleton } from './stas-details-skeleton';
import { useGetMySuperstarById } from '@wwe-portal/web/providers/queries/superstar-v2';

export const SuperstarDetailSource: FC<{ id: string; children: ReactNode }> = ({
  id,
  children,
}) => {
  const { data, isLoading } = useSuperstarDetails({ id });
  const { data: userSuperstar, isLoading: isUserSuperstarLoading } =
    useGetMySuperstarById(id);

  if (!data || isLoading || isUserSuperstarLoading) {
    return <StatsDetailsSkeleton />;
  }

  return (
    <SuperstarDetailProvider
      statsSheet={data.data}
      userSuperstar={userSuperstar}
    >
      {children}
    </SuperstarDetailProvider>
  );
};
